import { render } from "./TramitesAvancesGD.vue?vue&type=template&id=66549d01&scoped=true"
import script from "./TramitesAvancesGD.vue?vue&type=script&lang=js"
export * from "./TramitesAvancesGD.vue?vue&type=script&lang=js"

import "./TramitesAvancesGD.vue?vue&type=style&index=0&id=66549d01&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66549d01"]])

export default __exports__